import React from "react";
import { FormattedMessage } from "react-intl";
import { useParams } from "react-router-dom";

import { useGetInvoicePaymentBatchStatusQuery } from "~/api";
import { PaymentStatusMessage, RedesignPaymentStatusCard } from "~/components/common/payment-status-message";
import { Layout } from "~/components/ui/layout";
import { Portlet, PortletTitle } from "~/components/ui/portlet";
import { useIntlDocumentTitle } from "~/hooks/use-document-title";

export default function PaymentInvoiceBatchStatus({ bareLayout = false }: { bareLayout?: boolean }) {
  useIntlDocumentTitle("pat.payments.online.payment");

  const { batch_id } = useParams<{ batch_id: string }>();
  const invoiceQuery = useGetInvoicePaymentBatchStatusQuery({ batchId: batch_id });

  return (
    <Layout chrome={!bareLayout}>
      {bareLayout ? (
        <RedesignPaymentStatusCard titleId="pat.payments.online.payment" query={invoiceQuery} />
      ) : (
        <Portlet as="main" className="tw-h-full">
          <PortletTitle iconClassName="icon-book-open">
            <FormattedMessage id="pat.payments.online.payment" />
          </PortletTitle>

          <div className="portlet-body">
            <PaymentStatusMessage query={invoiceQuery} />
          </div>
        </Portlet>
      )}
    </Layout>
  );
}
